module.exports = __webpack_public_path__ + "img/1724249047949-IMG_1529.png.f8928ed3.webp";